import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DiscoverComponent } from './features/insights/pages/discover/discover.component';
import { HomeComponent } from './features/insights/pages/home/home.component';
import { LoginComponent } from './features/insights/pages/login/login.component';
import { AuthGuard } from './shared/utils/auth.guard';
import { RoleGuard } from './shared/utils/role.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'discover',
    component: DiscoverComponent,
  },
  {
    path: 'product/:name',
    loadComponent: () =>
      import('./features/insights/pages/product-detail/product-detail.component').then(
        (m) => m.ProductDetailComponent,
      ),
  },
  // {
  //   path: 'contact',
  //   component: FeedbackComponent,
  // },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [AuthGuard, MsalGuard],
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('./features/admin-portal/pages/admin-page/admin-page.component').then(
        (m) => m.AdminPageComponent,
      ),
    data: { roles: ['contributor', 'owner'] },
    canActivate: [RoleGuard, MsalGuard],
  },
  {
    path: 'admin/customers/:customerId',
    loadComponent: () =>
      import('./features/admin-portal/pages/customer-page/customer-page.component').then(
        (m) => m.CustomerPageComponent,
      ),
    data: { roles: ['contributor', 'owner'] },
    canActivate: [RoleGuard, MsalGuard],
  },
  {
    path: 'health-guard',
    loadComponent: () =>
      import('./features/health-guard/pages/health-guard-page/health-guard-page.component').then(
        (m) => m.HealthGuardPage,
      ),
    data: {
      roles: [
        'contributor',
        'owner',
        'Admin.ReadWrite',
        'HealthGuard.ReadWrite',
      ],
    },
    canActivate: [RoleGuard, MsalGuard],
  },
  {
    path: 'bluecreek',
    loadComponent: () =>
      import('./features/bluecreek/pages/bluecreek-overview-page/bluecreek-overview-page.component').then(
        (m) => m.BlueCreekOverviewPage,
      ),
    data: { roles: ['reader', 'contributor', 'owner'] },
    canActivate: [RoleGuard, MsalGuard],
  },
  {
    path: 'admin/onboarding',
    loadComponent: () =>
      import('./features/admin-portal/pages/onboard-customer-page/onboard-customer-page.component').then(
        (m) => m.OnboardCustomerPageComponent,
      ),
    data: { roles: ['contributor', 'owner'] },
    canActivate: [RoleGuard, MsalGuard],
  },
  {
    path: 'report',
    loadComponent: () =>
      import('./features/insights/pages/report/report.component').then(
        (m) => m.ReportComponent,
      ),
    canActivate: [AuthGuard, MsalGuard],
  },
  {
    path: 'service-tooling',
    loadChildren: () =>
      import('./features/service-tooling/service-tooling.routes').then(
        (m) => m.productsOverviewRoutes,
      ),
    data: { roles: ['reader', 'contributor', 'owner'] },
    canActivate: [AuthGuard, MsalGuard],
  },
  {
    path: 'notifications',
    loadComponent: () =>
      import('./features/insights/pages/notifications-page/notifications-page.component').then(
        (c) => c.NotificationsPage,
      ),
    data: { roles: ['reader', 'contributor', 'owner'] },
    canActivate: [AuthGuard, MsalGuard],
  },
  {
    path: '**',
    redirectTo: 'home',
  },
];
